import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSearchMeta } from 'shared/services/fetchSearchMeta';
import { IThunkApi } from 'shared/types/redux';
import { prepareJsonQuery } from './utils';
import { ISearchMeta } from 'shared/types/searchMeta';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectLocation } from 'shared/selectors/location';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const updateSearchMeta = createAsyncThunk<ISearchMeta, void, IThunkApiExtended>(
  'searchMeta/update',
  async (_, { getState, extra: context, rejectWithValue }) => {
    const state = getState();

    const jsonQuery = selectJsonQuery(state);
    const location = selectLocation(state);

    try {
      const preparedJsonQuery = prepareJsonQuery({ jsonQuery, location });

      const newMeta = await fetchSearchMeta(context, {
        jsonQuery: preparedJsonQuery,
      });

      return newMeta;
    } catch (e) {
      return rejectWithValue();
    }
  },
  {
    condition: (_, { getState }) => {
      const {
        searchMeta: { isLoading },
      } = getState();

      return !isLoading;
    },
  },
);
